// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  from { transform: rotate(180deg); }
  to   { transform: rotate(540deg); }
}

/* Card */
.card {
  margin-bottom: 30px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
}

.card-header,
.card-footer {
  border-color: #ebeef4;
  background-color: #fff;
  color: #798eb3;
  padding: 15px;
}

.user-webnexs .card-title {
  padding: 20px 0 15px 0;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.user-webnexs span.small.pt-1.fw-bold {
  color: black;
}

.card-title span {
  color: #899bbd;
  font-size: 14px;
  font-weight: 400;
}

.card-body {
  padding: 0 20px 20px 20px;
}

.card-img-overlay {
  background-color: rgba(255, 255, 255, 0.6);
}

.dashboard .nav-link {
  border-radius: 5px;
  border-bottom: 1px solid #e9e6e6;
  font-weight: 500;
  color: #000000;
  background-color: #e1e1e1;
}

.dashboard .nav-link.active {
  background: rgb(255 255 255 / 20%);
  font-size: 16px;
  font-weight: 500;
  color: #000;
}

.upload-video {
  background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;
}

/* .iq-card {
  background: #fff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  margin-bottom: 30px;
  border: none;
  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
  border-radius: 5px;
}


.iq-cards {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 30px;
  border: none;
  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);

} */

/* .days-cards {
  background: #fff;
  border-radius: 5px;
  border: none;
  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
  display: flex;
  align-items: center;
  padding: 10px;
} */

/* .progress-bar-vertical {
  position: relative;
  display: inline-block;
  height: 70px;
  width: 195px;
  background: linear-gradient(to right, #0d6efd 99.9%, transparent 99.9%), radial-gradient(circle at 50% 50%, #0d6efd 25%, transparent 30%);
  background-position: 0% 50%, 0% 50%;
  background-size: 100% 2px, 50px 15px;
  background-repeat: no-repeat, repeat-x;
} */

/* .progress-now-vertical {
  position: absolute;
  height: 100%;
  background: linear-gradient(to right, #0d6efd 99.9%, transparent 99.9%), radial-gradient(circle at 50% 50%, #0d6efd 25%, transparent 30%);


  background-position: 0% 50%, 0% 50%;
  background-size: 100% 5px, 50px 50px;
  background-repeat: no-repeat, repeat-x;
  z-index: 1;
} */

/* .progress-now-vertical.right {
  right: 0px;
  background-position: 100% 50%, 100% 50%;
} */

/* .section-con {
  height: 60vh;
} */

.sales-summary-title {
  margin: 5px 0;
  font-size: 1.5rem;
  text-align: left;
  padding: 3px;
}

/* .monthly-summary-title {
  margin: 20px 0;
  font-size: 1.5rem;
  text-align: left;
  padding: 3px;
} */
/* .month-subheading
{
  margin: 20px 0;
  font-size: 2rem;
  text-align: left;
  padding: 5px;
} */


/* .sales-summary-section, .monthly-summary-section {
  margin: 20px 0;
  padding: 15px;
  border: none;
  
} */
.ppv {
  border-radius: 5px;
  background-color: #fff;
}

/* .summary-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}


.summary-table th, .summary-table td {
  border-bottom: 1px solid #ddd;
  padding: 15px;
  text-align: left;
}

.summary-table th {
  font-weight:500;
} */

.dashboard-tabs .nav-link {
  border: none;
  border-radius: 0.5rem;
  background-color: #f0f0f0;
  margin-right: 0.5rem;
  color: #333;
  transition: all 0.3s ease;
  font-weight: 500;
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.dashboard-tabs .nav-link:hover {
  background-color: #e0e0e0;
  color: #000;
}

.dashboard-tabs .nav-link.active {
  background: #0d6efd !important;
  color: #fff !important;
  transform: scale(1.05);
}

.dashboard-tabs {
  border-bottom: none !important;
}

.dashboard-tabs .nav-link {
  border: none !important;
}

.live-button {
  position: relative;
  display: inline-block;
  color: #fff;
  background-color: #0d6efd;
  border-radius: 8px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  overflow: hidden;
}

.live-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(13, 110, 253, 0.5);
  color: #fff;
}

.live-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0));
  transition: all 0.4s ease;
}

.live-button:hover::before {
  left: 100%;
}

.live-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(13, 110, 253, 0.5);
}

.helpdesk-tooltip-card {
  position: absolute;
  bottom: 60px;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px 16px;
  width: 280px;
  max-width: 100%;
  z-index: 999;
  font-size: 13px;
  color: #333;
}

.helpdesk-tooltip-card p {
  font-size: 14px;
  margin-bottom: 0.5rem;
}

.trial-text {
  color: #1a2b4c;
}

.trial-banner {
  transition: transform 0.8s ease, opacity 0.8s ease;
  transform: translateX(0);
  opacity: 1;
  border: 1px solid #cfe0ff;
  font-size: 14px;
  padding: 12px 20px;
  border-radius: 8px;
  margin: 10px;
}

.trial-banner.closing {
  transform: translateX(100%);
  opacity: 0;
}

.purchase-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 8px 36px 8px 16px;
  border-radius: 999px;
  color: #fff;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.purchase-btn:hover {
  background: #155ab6;
  color: #fff;
}

.close-inside {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.close-inside:hover {
  background: rgba(0, 0, 0, 0.4);
}

.purchase-link {
  display: inline-block;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border-radius: 8px;
}

.purchase-link:hover {
  text-decoration: underline;
}

.renew-link {
  display: inline-block;
  background-color: #dc3545;
  /* Bootstrap danger red */
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.renew-link:hover {
  background-color: #bb2d3b;
  /* Darker red on hover */
  color: #fff;
  text-decoration: none;
  transform: translateY(-2px);
  /* subtle hover lift */
  box-shadow: 0 4px 10px rgba(220, 53, 69, 0.3);
}

.renew-link:active {
  transform: translateY(0);
  /* reset on click */
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.2);
}

.storage-details {
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  align-items: center;
  gap: 8px;
}

.guide-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex: 1 1 48%;
  min-width: 280px;
  max-width: 48%;
}

.guide-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}


iframe {
  width: 100%;
  border: none;
  border-radius: 10px !important;
}

.mySwiper .swiper-button-prev,
.mySwiper .swiper-button-next {
  --swiper-navigation-size: 30px;
  color: #0d6efd;
  opacity: 0.8;
  z-index: 10;
}

.mySwiper .swiper-button-prev:hover,
.mySwiper .swiper-button-next:hover {
  color: #0d6efd; 
  opacity: 1;
}

.playout-cta-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(13, 110, 253, 0.05) 100%);
  border: 2px solid rgba(13, 110, 253, 0.2) !important;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
  animation: card-highlight-pulse 3s infinite;
}

@keyframes card-highlight-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4);
    border-color: rgba(13, 110, 253, 0.4);
  }

  50% {
    box-shadow: 0 0 25px 5px rgba(13, 110, 253, 0.2);
    border-color: rgba(13, 110, 253, 0.6);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4);
    border-color: rgba(13, 110, 253, 0.4);
  }
}

.playout-cta-card:hover {
  transform: translateY(-5px) scale(1.01);
  box-shadow: 0 15px 35px rgba(13, 110, 253, 0.15) !important;
  border-color: rgba(13, 110, 253, 0.8) !important;
  animation: none;
  /* Stop pulsing on hover */
}

.playout-cta-icon-wrapper {
  position: relative;
  padding: 18px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 20px rgba(13, 110, 253, 0.1);
  border: 1px solid rgba(13, 110, 253, 0.05);
}

.hand-gesture-ping {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: hand-ping 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;
  border: 2px solid #0d6efd;
}

.hand-icon {
  font-size: 20px;
}

@keyframes hand-ping {
  0% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.6);
  }

  50% {
    transform: scale(1.2) rotate(-10deg);
    box-shadow: 0 0 0 15px rgba(13, 110, 253, 0);
  }

  100% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
  }
}

.explore-arrow {
  transition: transform 0.2s ease;
}

.btn-primary:hover .explore-arrow {
  transform: translateX(4px);
}

/* Modal Styling */
.playout-reminder-modal .modal-content {
  border-radius: 20px;
  border: none;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
}

.reminder-icon-bg {
  animation: pulse-glow 2s infinite;
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }

  50% {
    transform: scale(1.05);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}

.cta-highlight-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  z-index: 9998;
  cursor: pointer;
  animation: overlay-fade-in 0.5s ease-out;
}

@keyframes overlay-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.cta-highlighted {
  position: relative;
  z-index: 9999 !important;
  pointer-events: auto;
}

/* Usage Details Modal Optimized Dimensions */
.modal-85w {
  max-width: 1050px !important;
  width: auto !important;
  height: auto !important;
  margin: 1.75rem auto;
}

@media (max-width: 992px) {
  .modal-85w {
    max-width: 95% !important;
    width: 95% !important;
    margin: 10px auto !important;
  }
}


.usage-details-modal .modal-content {
  border-radius: 24px;
  border: none;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.usage-details-modal .modal-header {
  background: linear-gradient(to right, #f8faff, #ffffff);
}

.usage-details-modal .table-responsive {
  scrollbar-width: thin;
  scrollbar-color: #dee2e6 transparent;
}

.usage-details-modal .table-responsive::-webkit-scrollbar {
  height: 6px;
}

.usage-details-modal .table-responsive::-webkit-scrollbar-thumb {
  background-color: #dee2e6;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,OAAO,yBAAyB,EAAE;EAClC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;;;;GAUG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;;GAKG;AACH;;;;;;GAMG;;;AAGH;;;;;GAKG;AACH;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,wBAAwB;EACxB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,+FAA+F;EAC/F,oDAAoD;EACpD,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE;IACE,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,gDAAgD;IAChD,qCAAqC;EACvC;;EAEA;IACE,2CAA2C;IAC3C,qCAAqC;EACvC;AACF;;AAEA;EACE,uCAAuC;EACvC,2DAA2D;EAC3D,gDAAgD;EAChD,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,0EAA0E;EAC1E,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gCAAgC;IAChC,2CAA2C;EAC7C;;EAEA;IACE,oCAAoC;IACpC,4CAA4C;EAC9C;;EAEA;IACE,gCAAgC;IAChC,yCAAyC;EAC3C;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;EAC9B;AACF;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["@keyframes spin {\r\n  from { transform: rotate(180deg); }\r\n  to   { transform: rotate(540deg); }\r\n}\r\n\r\n/* Card */\r\n.card {\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\r\n}\r\n\r\n.card-header,\r\n.card-footer {\r\n  border-color: #ebeef4;\r\n  background-color: #fff;\r\n  color: #798eb3;\r\n  padding: 15px;\r\n}\r\n\r\n.user-webnexs .card-title {\r\n  padding: 20px 0 15px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #000000;\r\n}\r\n\r\n.user-webnexs span.small.pt-1.fw-bold {\r\n  color: black;\r\n}\r\n\r\n.card-title span {\r\n  color: #899bbd;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.card-body {\r\n  padding: 0 20px 20px 20px;\r\n}\r\n\r\n.card-img-overlay {\r\n  background-color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.dashboard .nav-link {\r\n  border-radius: 5px;\r\n  border-bottom: 1px solid #e9e6e6;\r\n  font-weight: 500;\r\n  color: #000000;\r\n  background-color: #e1e1e1;\r\n}\r\n\r\n.dashboard .nav-link.active {\r\n  background: rgb(255 255 255 / 20%);\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #000;\r\n}\r\n\r\n.upload-video {\r\n  background-color: #fafafa;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* .iq-card {\r\n  background: #fff;\r\n  -webkit-border-radius: 5px;\r\n  -moz-border-radius: 5px;\r\n  border-radius: 5px;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n.iq-cards {\r\n  background: #fff;\r\n  border-radius: 5px;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\r\n\r\n} */\r\n\r\n/* .days-cards {\r\n  background: #fff;\r\n  border-radius: 5px;\r\n  border: none;\r\n  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n} */\r\n\r\n/* .progress-bar-vertical {\r\n  position: relative;\r\n  display: inline-block;\r\n  height: 70px;\r\n  width: 195px;\r\n  background: linear-gradient(to right, #0d6efd 99.9%, transparent 99.9%), radial-gradient(circle at 50% 50%, #0d6efd 25%, transparent 30%);\r\n  background-position: 0% 50%, 0% 50%;\r\n  background-size: 100% 2px, 50px 15px;\r\n  background-repeat: no-repeat, repeat-x;\r\n} */\r\n\r\n/* .progress-now-vertical {\r\n  position: absolute;\r\n  height: 100%;\r\n  background: linear-gradient(to right, #0d6efd 99.9%, transparent 99.9%), radial-gradient(circle at 50% 50%, #0d6efd 25%, transparent 30%);\r\n\r\n\r\n  background-position: 0% 50%, 0% 50%;\r\n  background-size: 100% 5px, 50px 50px;\r\n  background-repeat: no-repeat, repeat-x;\r\n  z-index: 1;\r\n} */\r\n\r\n/* .progress-now-vertical.right {\r\n  right: 0px;\r\n  background-position: 100% 50%, 100% 50%;\r\n} */\r\n\r\n/* .section-con {\r\n  height: 60vh;\r\n} */\r\n\r\n.sales-summary-title {\r\n  margin: 5px 0;\r\n  font-size: 1.5rem;\r\n  text-align: left;\r\n  padding: 3px;\r\n}\r\n\r\n/* .monthly-summary-title {\r\n  margin: 20px 0;\r\n  font-size: 1.5rem;\r\n  text-align: left;\r\n  padding: 3px;\r\n} */\r\n/* .month-subheading\r\n{\r\n  margin: 20px 0;\r\n  font-size: 2rem;\r\n  text-align: left;\r\n  padding: 5px;\r\n} */\r\n\r\n\r\n/* .sales-summary-section, .monthly-summary-section {\r\n  margin: 20px 0;\r\n  padding: 15px;\r\n  border: none;\r\n  \r\n} */\r\n.ppv {\r\n  border-radius: 5px;\r\n  background-color: #fff;\r\n}\r\n\r\n/* .summary-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n}\r\n\r\n\r\n.summary-table th, .summary-table td {\r\n  border-bottom: 1px solid #ddd;\r\n  padding: 15px;\r\n  text-align: left;\r\n}\r\n\r\n.summary-table th {\r\n  font-weight:500;\r\n} */\r\n\r\n.dashboard-tabs .nav-link {\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  background-color: #f0f0f0;\r\n  margin-right: 0.5rem;\r\n  color: #333;\r\n  transition: all 0.3s ease;\r\n  font-weight: 500;\r\n  padding: 0.5rem 1rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.dashboard-tabs .nav-link:hover {\r\n  background-color: #e0e0e0;\r\n  color: #000;\r\n}\r\n\r\n.dashboard-tabs .nav-link.active {\r\n  background: #0d6efd !important;\r\n  color: #fff !important;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.dashboard-tabs {\r\n  border-bottom: none !important;\r\n}\r\n\r\n.dashboard-tabs .nav-link {\r\n  border: none !important;\r\n}\r\n\r\n.live-button {\r\n  position: relative;\r\n  display: inline-block;\r\n  color: #fff;\r\n  background-color: #0d6efd;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.live-button:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: 0 0 10px rgba(13, 110, 253, 0.5);\r\n  color: #fff;\r\n}\r\n\r\n.live-button::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(120deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0));\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.live-button:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.live-button:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: 0 0 10px rgba(13, 110, 253, 0.5);\r\n}\r\n\r\n.helpdesk-tooltip-card {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  right: 0;\r\n  background: #fff;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 12px;\r\n  padding: 12px 16px;\r\n  width: 280px;\r\n  max-width: 100%;\r\n  z-index: 999;\r\n  font-size: 13px;\r\n  color: #333;\r\n}\r\n\r\n.helpdesk-tooltip-card p {\r\n  font-size: 14px;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.trial-text {\r\n  color: #1a2b4c;\r\n}\r\n\r\n.trial-banner {\r\n  transition: transform 0.8s ease, opacity 0.8s ease;\r\n  transform: translateX(0);\r\n  opacity: 1;\r\n  border: 1px solid #cfe0ff;\r\n  font-size: 14px;\r\n  padding: 12px 20px;\r\n  border-radius: 8px;\r\n  margin: 10px;\r\n}\r\n\r\n.trial-banner.closing {\r\n  transform: translateX(100%);\r\n  opacity: 0;\r\n}\r\n\r\n.purchase-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  white-space: nowrap;\r\n  padding: 8px 36px 8px 16px;\r\n  border-radius: 999px;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.purchase-btn:hover {\r\n  background: #155ab6;\r\n  color: #fff;\r\n}\r\n\r\n.close-inside {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 12px;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  width: 18px;\r\n  height: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.close-inside:hover {\r\n  background: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.purchase-link {\r\n  display: inline-block;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  border-radius: 8px;\r\n}\r\n\r\n.purchase-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.renew-link {\r\n  display: inline-block;\r\n  background-color: #dc3545;\r\n  /* Bootstrap danger red */\r\n  color: #fff;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  padding: 10px 24px;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.renew-link:hover {\r\n  background-color: #bb2d3b;\r\n  /* Darker red on hover */\r\n  color: #fff;\r\n  text-decoration: none;\r\n  transform: translateY(-2px);\r\n  /* subtle hover lift */\r\n  box-shadow: 0 4px 10px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.renew-link:active {\r\n  transform: translateY(0);\r\n  /* reset on click */\r\n  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.2);\r\n}\r\n\r\n.storage-details {\r\n  padding: 12px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  backdrop-filter: blur(8px);\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.guide-card {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  flex: 1 1 48%;\r\n  min-width: 280px;\r\n  max-width: 48%;\r\n}\r\n\r\n.guide-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n\r\niframe {\r\n  width: 100%;\r\n  border: none;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.mySwiper .swiper-button-prev,\r\n.mySwiper .swiper-button-next {\r\n  --swiper-navigation-size: 30px;\r\n  color: #0d6efd;\r\n  opacity: 0.8;\r\n  z-index: 10;\r\n}\r\n\r\n.mySwiper .swiper-button-prev:hover,\r\n.mySwiper .swiper-button-next:hover {\r\n  color: #0d6efd; \r\n  opacity: 1;\r\n}\r\n\r\n.playout-cta-card {\r\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(13, 110, 253, 0.05) 100%);\r\n  border: 2px solid rgba(13, 110, 253, 0.2) !important;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  z-index: 10;\r\n  animation: card-highlight-pulse 3s infinite;\r\n}\r\n\r\n@keyframes card-highlight-pulse {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4);\r\n    border-color: rgba(13, 110, 253, 0.4);\r\n  }\r\n\r\n  50% {\r\n    box-shadow: 0 0 25px 5px rgba(13, 110, 253, 0.2);\r\n    border-color: rgba(13, 110, 253, 0.6);\r\n  }\r\n\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4);\r\n    border-color: rgba(13, 110, 253, 0.4);\r\n  }\r\n}\r\n\r\n.playout-cta-card:hover {\r\n  transform: translateY(-5px) scale(1.01);\r\n  box-shadow: 0 15px 35px rgba(13, 110, 253, 0.15) !important;\r\n  border-color: rgba(13, 110, 253, 0.8) !important;\r\n  animation: none;\r\n  /* Stop pulsing on hover */\r\n}\r\n\r\n.playout-cta-icon-wrapper {\r\n  position: relative;\r\n  padding: 18px;\r\n  background: #fff;\r\n  border-radius: 20px;\r\n  box-shadow: 0 8px 20px rgba(13, 110, 253, 0.1);\r\n  border: 1px solid rgba(13, 110, 253, 0.05);\r\n}\r\n\r\n.hand-gesture-ping {\r\n  position: absolute;\r\n  top: -12px;\r\n  right: -12px;\r\n  background: #fff;\r\n  border-radius: 50%;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  animation: hand-ping 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;\r\n  border: 2px solid #0d6efd;\r\n}\r\n\r\n.hand-icon {\r\n  font-size: 20px;\r\n}\r\n\r\n@keyframes hand-ping {\r\n  0% {\r\n    transform: scale(1) rotate(0deg);\r\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.6);\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.2) rotate(-10deg);\r\n    box-shadow: 0 0 0 15px rgba(13, 110, 253, 0);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1) rotate(0deg);\r\n    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);\r\n  }\r\n}\r\n\r\n.explore-arrow {\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.btn-primary:hover .explore-arrow {\r\n  transform: translateX(4px);\r\n}\r\n\r\n/* Modal Styling */\r\n.playout-reminder-modal .modal-content {\r\n  border-radius: 20px;\r\n  border: none;\r\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.reminder-icon-bg {\r\n  animation: pulse-glow 2s infinite;\r\n}\r\n\r\n@keyframes pulse-glow {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 0.8;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.05);\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 0.8;\r\n  }\r\n}\r\n\r\n.cta-highlight-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.75);\r\n  z-index: 9998;\r\n  cursor: pointer;\r\n  animation: overlay-fade-in 0.5s ease-out;\r\n}\r\n\r\n@keyframes overlay-fade-in {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.cta-highlighted {\r\n  position: relative;\r\n  z-index: 9999 !important;\r\n  pointer-events: auto;\r\n}\r\n\r\n/* Usage Details Modal Optimized Dimensions */\r\n.modal-85w {\r\n  max-width: 1050px !important;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  margin: 1.75rem auto;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .modal-85w {\r\n    max-width: 95% !important;\r\n    width: 95% !important;\r\n    margin: 10px auto !important;\r\n  }\r\n}\r\n\r\n\r\n.usage-details-modal .modal-content {\r\n  border-radius: 24px;\r\n  border: none;\r\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n}\r\n\r\n.usage-details-modal .modal-header {\r\n  background: linear-gradient(to right, #f8faff, #ffffff);\r\n}\r\n\r\n.usage-details-modal .table-responsive {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #dee2e6 transparent;\r\n}\r\n\r\n.usage-details-modal .table-responsive::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n\r\n.usage-details-modal .table-responsive::-webkit-scrollbar-thumb {\r\n  background-color: #dee2e6;\r\n  border-radius: 10px;\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
